import { useCallback, useEffect, useState } from 'react'

import { DefaultBadges } from '@/entities/user'

import { useBadgeDatabase } from '../api/database'

type Props = {
  isLoggedIn: boolean
  userId?: number
}

export const useBadges = ({ isLoggedIn, userId: userIdProp }: Props) => {
  const [badges, setBadges] = useState(DefaultBadges)

  const { getBadges, subscribeBadges } = useBadgeDatabase()

  const initializeBadges = useCallback(
    async (userId: number) => {
      const badges = await getBadges(userId)

      setBadges(badges)
    },
    [getBadges],
  )

  useEffect(() => {
    if (!isLoggedIn || !userIdProp) return

    void initializeBadges(userIdProp)

    const { unsubscribe } = subscribeBadges(userIdProp, setBadges)

    return () => {
      unsubscribe()
    }
  }, [isLoggedIn, userIdProp, subscribeBadges, initializeBadges])

  return { badges }
}
